export const SaasLogo = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="34" height="34" rx="3.5" stroke="#05050D" strokeOpacity="0.05" />
      <path
        d="M9.94444 9H25.0556C25.306 9 25.5463 9.0995 25.7234 9.27662C25.9005 9.45374 26 9.69396 26 9.94444V16.5556H9V9.94444C9 9.69396 9.0995 9.45374 9.27662 9.27662C9.45374 9.0995 9.69396 9 9.94444 9ZM9 18.4444H26V25.0556C26 25.306 25.9005 25.5463 25.7234 25.7234C25.5463 25.9005 25.306 26 25.0556 26H9.94444C9.69396 26 9.45374 25.9005 9.27662 25.7234C9.0995 25.5463 9 25.306 9 25.0556V18.4444ZM12.7778 21.2778V23.1667H15.6111V21.2778H12.7778ZM12.7778 11.8333V13.7222H15.6111V11.8333H12.7778Z"
        fill="#05050D"
        fillOpacity="0.3"
      />
    </svg>
  );
};
